/**
 * Clarity and GTM run only when both are true:
 * - NODE_ENV is production (`npm run build`)
 * - NEXT_PUBLIC_ANALYTICS=true
 *
 * Staging also uses `npm run build` (NODE_ENV=production), so leave
 * NEXT_PUBLIC_ANALYTICS unset or false there.
 */
export function isAnalyticsEnabled() {
  return (
    process.env.NODE_ENV === "production" &&
    process.env.NEXT_PUBLIC_ANALYTICS === "true"
  );
}
